import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { reducers } from './reducers'

export default (initialState?: any) => {
  const middlewares = composeWithDevTools(
    applyMiddleware(thunkMiddleware)
  )
  return createStore(reducers, initialState, middlewares)
}
